export class ErrorArray extends Error {
  public readonly errors?: string[]
}
